import { useState } from 'react';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Dialog from '@mui/material/Dialog';
import { useTranslation } from 'react-i18next';
import { Box, FormControlLabel, Radio, RadioGroup } from '@mui/material';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { useSelector } from 'react-redux';
import { selectTestCaseDataLocal } from '@pages/testcases/store/selectors';
import UtmsButton from '@shared/components/ui/UtmsButton';
import { toTitleCase } from '@shared/utils/utilsOld';

const TestcaseStepCloneDialog = ({ open, setOpen, stepIndex, handleSubmit }) => {
    const [placeDirection, setPlaceDirection] = useState('after');
    const [placeItemIndexAfter, setPlaceItemIndexAfter] = useState(stepIndex);
    const [placeItemIndexBefore, setPlaceItemIndexBefore] = useState(stepIndex);
    const { t } = useTranslation();

    const handleClose = () => {
        setOpen(false);
    };

    const handleSubmitButton = () => {
        handleSubmit({
            direction: placeDirection,
            stepToPlaceIndex: placeDirection === 'after' ? placeItemIndexAfter : placeItemIndexBefore,
        });
        handleClose();
    };

    const handleChangePlaceDirection = (event) => {
        setPlaceDirection(event.target.value);
    };

    return (
        <Dialog
            PaperProps={{
                sx: {
                    width: '384px',
                },
            }}
            open={open}
            onClose={handleClose}
        >
            <DialogTitle variant="h4">{`${t('clone')} ${toTitleCase(t('step'))} ${stepIndex + 1}`}</DialogTitle>
            <DialogContent sx={{ pb: 0, display: 'flex', flexDirection: 'column', gap: 1 }}>
                {`${t('place_cloned_step')}:`}
                <Box sx={{ display: 'flex', gap: 2 }}>
                    <RadioGroup
                        sx={{ gap: 1 }}
                        color="secondary"
                        value={placeDirection}
                        onChange={handleChangePlaceDirection}
                    >
                        <FormControlLabel value="after" control={<Radio color="secondary" />} label={t('after')} />
                        <FormControlLabel value="before" control={<Radio color="secondary" />} label={t('before')} />
                    </RadioGroup>
                    <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                        <PlaceItemIndexSelect
                            isActive={placeDirection === 'after'}
                            stepIndex={stepIndex}
                            placeItemIndex={placeItemIndexAfter}
                            setPlaceItemIndex={setPlaceItemIndexAfter}
                        />
                        <PlaceItemIndexSelect
                            isActive={placeDirection === 'before'}
                            stepIndex={stepIndex}
                            placeItemIndex={placeItemIndexBefore}
                            setPlaceItemIndex={setPlaceItemIndexBefore}
                        />
                    </Box>
                </Box>
            </DialogContent>
            <DialogActions>
                <UtmsButton onClick={handleSubmitButton} autoFocus>
                    {t('clone')}
                </UtmsButton>
                <UtmsButton onClick={handleClose} color="secondary">
                    {t('cancel')}
                </UtmsButton>
            </DialogActions>
        </Dialog>
    );
};

export default TestcaseStepCloneDialog;

const PlaceItemIndexSelect = ({ isActive, stepIndex, placeItemIndex, setPlaceItemIndex }) => {
    const testcaseDataLocal = useSelector(selectTestCaseDataLocal);
    const { t } = useTranslation();

    const handleChangePlaceItemIndex = (event) => {
        setPlaceItemIndex(event.target.value);
    };

    return (
        <Select
            disabled={!isActive}
            size="small"
            sx={{ width: '144px' }}
            value={placeItemIndex}
            onChange={handleChangePlaceItemIndex}
        >
            {testcaseDataLocal.test_scripts.map((step, index, array) => {
                let title;
                if (index === stepIndex) {
                    title = toTitleCase(t('current_m_r'));
                } else if (index === 0) {
                    title = toTitleCase(t('first_m_r'));
                } else if (index === array.length - 1) {
                    title = toTitleCase(t('last_m_r'));
                } else {
                    title = index + 1;
                }

                return <MenuItem value={index}>{title}</MenuItem>;
            })}
        </Select>
    );
};
